import { Sezzle } from "@ThirdParty/Sezzle";

export class ReviewGroupPage
{
	constructor()
	{
		this.Initialize();
	}

	public Initialize = (): void =>
	{
		this.BindSezzleInfo();
	};

	private BindSezzleInfo = (): void =>
	{
		const sezzleInfo = document.getElementById("sezzleInfo");

		if (sezzleInfo !== null)
		{
			const sezzle = new Sezzle();

			sezzle.BindInformationLink(sezzleInfo);
		}
	};
}